module.exports = __webpack_public_path__ + "img/singularegestao1.25a318e7.png";